<template>
	<div class="page">
		<!-- your page -->
		<div class="more">
			<div class="item" v-for="item in list" :data-id="item.id" @click="goParticulars">
				<div class="img" :data-id="item.id">
					<img :src="item.img" alt="" :data-id="item.id">
				</div>
				<div class="name" :data-id="item.id">
					{{item.name}}
				</div>
				<div class="price" :data-id="item.id">
					<div class="nowPrice" :data-id="item.id">
						¥{{item.nowPrice}}
					</div>
					<div class="originPrice" :data-id="item.id">
						¥{{item.originPrice}}
					</div>
				</div>
				<div class="sale" :data-id="item.id">
					销量:{{item.sale}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// your script
	export default {
		name: 'more',
		data(){
			return {
				list:[
					// {"id":"1","img":require('../assets/index/imgList1.jpg'),"name":"巨无霸超级章鱼汉堡","nowPrice":"2400.00","originPrice":"3600.00","sale":"1200"},
					// {"id":"2","img":require('../assets/index/imgList2.jpg'),"name":"巨无霸超级章鱼汉堡","nowPrice":"2400.00","originPrice":"3600.00","sale":"1200"},
					// {"id":"3","img":require('../assets/index/imgList3.jpg'),"name":"巨无霸超级章鱼汉堡","nowPrice":"2400.00","originPrice":"3600.00","sale":"1200"},
					// {"id":"4","img":require('../assets/index/imgList4.jpg'),"name":"巨无霸超级章鱼汉堡","nowPrice":"2400.00","originPrice":"3600.00","sale":"1200"},
					// {"id":"5","img":require('../assets/index/imgList5.jpg'),"name":"巨无霸超级章鱼汉堡","nowPrice":"2400.00","originPrice":"3600.00","sale":"1200"},
					// {"id":"6","img":require('../assets/index/imgList6.jpg'),"name":"巨无霸超级章鱼汉堡","nowPrice":"2400.00","originPrice":"3600.00","sale":"1200"}
				]
			}
		},
		methods:{
			goParticulars(e){
				var id = e.target.dataset.id
				this.$router.push({path:'/particulars',query:{cid:id,from:'normal'}})
				this.$parent.reload()
			},
			fetchRecommend(){
				var list = this.list
				var page = this.page
				var data = {
					"method":"goods.getlist",
					"where":"{'recommend':1}",
					"limit":6,
					"page":1
				}
				var that = this
				this.request(data,function(res){
					var resList = res.data.list
					var arr = new Array()
					for (var i = 0; i < resList.length; i++) {
						var obj = {
							"img":resList[i].image_url,
							"id":resList[i].id,
							"name":resList[i].name,
							"nowPrice":resList[i].price,
							"originPrice":resList[i].mktprice,
							"sale":resList[i].freeze_stock
						}
						list.push(obj)
					}
					that.list = list
				})
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.fetchRecommend()
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.more{
		padding-bottom: 10px;
		box-sizing: border-box;
		/* border: 1px solid #D3D3D3; */
	}
	.item{
		width: 250px;
		box-sizing: border-box;
		margin: 0px auto;
		margin-top: 10px;
		cursor: pointer;
		border: 1px solid #D3D3D3;
	}
	.item .img{
		width: 100%;
		height: 250px;
		overflow: hidden;
		border-bottom: 1px solid #F3F3F3;
		box-sizing: border-box;
	}
	.item .img img{
		width: 100%;
		display: block;
	}
	.name{
		width: 100%;
		padding: 5px;
		box-sizing: border-box;
		line-height: 24px;
		border-bottom: none;
	}
	.price,.sale{
		padding:0px 5px;
		box-sizing: border-box;
	}
	.price{
		width: 100%;
		height: 26px;
		line-height: 26px;
	}
	.nowPrice,.originPrice{
		width: 50%;
		height: 100%;
		float: left;
	}
	.nowPrice{
		color: red;
	}
	.originPrice{
		color: #838383;
		font-size: 12px;
		text-decoration: line-through;
	}
	.sale{
		width: 100%;
		height: 26px;
		line-height: 26px;
		font-size: 12px;
		color: #838383;
	}
</style>
